import React, { useEffect, useState } from "react";

function Navbar({ activePage, onNavigate, onLogout }) {
    const [time, setTime] = useState("");

    useEffect(() => {
        const updateClock = () => {
            const now = new Date();
            setTime(now.toTimeString().slice(0, 8));
        };
        updateClock();
        const interval = setInterval(updateClock, 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <nav>
            <div className="logo" onClick={() => onNavigate("live")}>
                <div className="logo-text">METAGAIM</div>
                <div className="logo-pill">Virtual IPL</div>
            </div>
            <ul className="nav-links">
                <li><a className={activePage === "live" ? "active" : ""} onClick={() => onNavigate("live")}>Live</a></li>
                <li><a className={activePage === "results" ? "active" : ""} onClick={() => onNavigate("results")}>Results</a></li>
                <li><a className={activePage === "schedule" ? "active" : ""} onClick={() => onNavigate("schedule")}>Schedule</a></li>
                <li><a className={activePage === "stats" ? "active" : ""} onClick={() => onNavigate("stats")}>Stats</a></li>
                <li><a className={activePage === "standings" ? "active" : ""} onClick={() => onNavigate("standings")}>Standings</a></li>
            </ul>
            <div className="nav-right">
                <div className="nav-time">{time}</div>
                <div className="live-ping">
                    <div className="ping-dot"></div>LIVE
                </div>
                <button onClick={onLogout} style={{
                    background: "transparent",
                    border: "1px solid var(--border2)",
                    color: "var(--text3)",
                    fontSize: "10px",
                    fontWeight: "700",
                    letterSpacing: "1px",
                    padding: "4px 10px",
                    cursor: "pointer",
                    fontFamily: "var(--font-b)",
                    textTransform: "uppercase"
                }}>Logout</button>
            </div>
        </nav>
    );
}

export default Navbar;